// @flow

export default new Set<string>([
  "esnext.global-this",
  "esnext.string.match-all",
]);
